import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { queryCache } from "react-query";
import CustomInputField from "../../../../CustomHTMLElements/CustomInputField";
import { TextEditor } from "../../../../../helpers/TextEditor";
import { Button, message } from "antd";
import { errorHandler } from "../../../../../helpers/errorHandler";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";
import { patchData, postData } from "../../../../../newApis/dotNetApiMethods";
import { AxiosResponse } from "axios";

const schema = yup.object().shape({
  title: yup.string().trim().required("Please enter title"),
  editorContent: yup
    .string()
    .test("not-empty", "Please enter terms and conditions", (value) => {
      if (!value) return false;
      const text = value.replace(/<(.|\n)*?>/g, "").trim();
      return text.length > 0;
    }),
});

type FormData = {
  title: string;
  editorContent: string;
};

const CreateTermsAndConditionsModal = ({ onCloseModal, dataRecord }: any) => {
  const [isCreating, setIsCreating] = useState(false);

  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const handleCreatEditTermsAndCondition = async (values: FormData) => {
    setIsCreating(true);
    const reqBody = {
      title: values?.title,
      termsAndConditions: values?.editorContent,
    };

    let response: AxiosResponse<any, any>;
    try {
      if (!dataRecord) {
        response = await postData(
          ajaxEndpoints.DB_TERMS_AND_CONDITIONS,
          reqBody
        );
      } else {
        response = await patchData(ajaxEndpoints.DB_TERMS_AND_CONDITIONS, {
          ...reqBody,
          id: dataRecord?.id,
        });
      }

      message.success(response?.data?.message);
      queryCache.invalidateQueries("termsAndConditions");

      setTimeout(() => {
        onCloseModal();
      }, 2000);
    } catch (error) {
      message.error(errorHandler(error));
    } finally {
      setIsCreating(false);
    }
  };

  const handleEditorChange = (text: string) => {};

  useEffect(() => {
    setValue("editorContent", dataRecord?.termsAndConditions);
  }, []);

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1" style={{ fontWeight: "700" }}>
              {!dataRecord
                ? "Create New Terms & Conditions"
                : "Edit Terms & Conditions"}
            </h3>

            <div>
              <div className="m-b-30">
                <form onSubmit={handleSubmit(handleCreatEditTermsAndCondition)}>
                  <div className="row">
                    <div className="col-12">
                      <CustomInputField
                        label="Title"
                        type="text"
                        name="title"
                        defaultValue={dataRecord?.title}
                        reference={register}
                        errors={errors.title}
                      />

                      <div className="w-100">
                        <TextEditor
                          onChange={handleEditorChange}
                          defaultValue={
                            dataRecord?.termsAndConditions
                              ? dataRecord?.termsAndConditions
                              : ""
                          }
                          register={register}
                          setValue={setValue}
                          errors={errors}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end m-t-2">
                    <Button
                      htmlType="button"
                      onClick={() => {
                        onCloseModal();
                      }}
                      size={"large"}
                      className=""
                    >
                      <i className="fa fa-save" /> Cancel
                    </Button>

                    <Button
                      htmlType="submit"
                      type="primary"
                      className="m-l-1"
                      size={"large"}
                      loading={isCreating}
                    >
                      <i className="fa fa-check-circle" />{" "}
                      {!dataRecord ? "Create" : "Update"}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default CreateTermsAndConditionsModal;
